module.exports = __webpack_public_path__ + "static/media/LoyalityProgramsCards1.69e3f9a2.png";